import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';

import HomeAddress from './HomeAddress';
import HomePrice from './HomePrice';

const styles = css`
  margin: 20px 0 0;
  @media(min-width: 992px) {
    margin: 48px auto 0;
    max-width: 1900px;
  }
  .HomeDetails_wrapper {
    @media(min-width: 992px) {
      border-bottom: 6px solid #D3D3D3;
    }
  }
`;

function HomeDetails({ home, plan, community }) {
  return (
    <div className={styles}>
      <div className="container-fluid">
        <div className="d-lg-flex HomeDetails_wrapper">
          <HomeAddress home={home} plan={plan} className="col-lg-6 mb-2 px-0" />
          <HomePrice home={home} community={community} className="col-lg-6 px-0" />
        </div>
      </div>
    </div>
  );
}

HomeDetails.propTypes = {
  home: PropTypes.object.isRequired,
  plan: PropTypes.object,
  community: PropTypes.object.isRequired,
};

HomeDetails.defaultProps = {
  plan: undefined,
};

export default HomeDetails;



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/HomeDetails/index.js